import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { NarrativeQuestionnaireItem } from './questionnaire'

export const NARRATIVE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [NarrativeQuestionnaireItem.NARRATIVE_BACKGROUND]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_SYSTEM_SUMMARIES]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_CLINICAL_OVERVIEW]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_SKILLED_NEEDS]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_ADL_NEEDS]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_PATIENT_SERVICES]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_CARE_COORDINATION]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_PATIENT_GOALS]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_CLINICAL_EDUCATION]: QuestionnaireAnswerType.STRING,
  [NarrativeQuestionnaireItem.NARRATIVE_FINAL_NOTES]: QuestionnaireAnswerType.STRING
}
